import React from "react";
import { useSelector } from "react-redux";
import showdown from "showdown";
import classnames from "classnames";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(
    currentActivity.websiteData.inspirationWorkshop.subtitle
  );
  return (
    <>
      {currentActivity &&
        currentActivity.websiteData &&
        (currentActivity.websiteData.inspirationWorkshop.title ||
          currentActivity.websiteData.inspirationWorkshop.data.description) && (
          <div
            id="easyinstall"
            className="gradiant-background pwg-section section steps-section pbm-0"
          >
            <div className="container">
              <div className="section-head heading-light text-center">
                <div className="row">
                  <div className="col-md-8 col-md-offset-2">
                    <h2 className="heading heading-light">
                      {currentActivity.websiteData.inspirationWorkshop.title
                        ? currentActivity.websiteData.inspirationWorkshop.title
                        : "Please complete the workshop section title"}
                    </h2>
                    {currentActivity.websiteData.inspirationWorkshop
                      .subtitle && (
                      <p
                        className="h4 heading-light"
                        dangerouslySetInnerHTML={{ __html: subtitle }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {currentActivity.websiteData.inspirationWorkshop.data.image && (
                <div className="d-flex mb-5">
                  <img
                    src={
                      currentActivity.websiteData.inspirationWorkshop.data.image
                    }
                    style={{ margin: "auto", width: " 50%" }}
                  ></img>
                </div>
              )}
              <div className="row tab-center mobile-center row-vm ">
                <div className="col-md-8 col-md-offset-2">
                  <div className="txt-entry txt-feature text-center ">
                    <p
                      className="whitetxt"
                      style={{
                        color: "white",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: converter.makeHtml(
                          currentActivity.websiteData.inspirationWorkshop.data
                            .description
                            ? currentActivity.websiteData.inspirationWorkshop
                                .data.description
                            : "please complete description"
                        ),
                      }}
                    />
                    <a
                      className="button solid-btn sb-h"
                      href={`https://applyforms.lafactory.co/${currentActivity._id}/`}
                      target="_blank"
                      rel="noopener noreferrer"
                      // style={{
                      //   backgroundColor: "#638b18",
                      // }}
                    >
                      S'INSCRIRE
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};
